class Gallery {
    constructor(gallery) {
        
        const galleryEl = gallery.querySelector(`[data-gallery-el]`);
        const countInfo = gallery.querySelector(`[data-counter]`);

        const lg = lightGallery(galleryEl, {
            speed: 500,
            container: galleryEl,
            plugins: [lgThumbnail, lgFullscreen],
            licenseKey: "4628D369-F2EC4BF8-98F3F83B-F7312AC5",
            closable: false,
            hash: false,
            showCloseIcon: false,
            controls: false,
            download: false,
            appendSubHtmlTo: '.lg-item',
            thumbHeight: '80px',
            thumbWidth: 120,
            thumbMargin: 20,
            fullscreen: true,
            showMaximizeIcon: true,
            exThumbImage: 'data-external-thumb-image'
        });
        lg.openGallery(0);

        const itemCount = lg.galleryItems.length;
        
        const dialogue = lg.el.querySelector(".lg-container");

        dialogue.setAttribute("aria-labelledby","lg-inner-1");

        galleryEl.addEventListener('lgBeforeSlide', (galleryEl) => {
            countInfo.innerHTML = `${(galleryEl.detail.index + 1)} of ${itemCount}`;
        });
        
        galleryEl.querySelectorAll(".lg-thumb-item").forEach(thumb => {
            thumb.setAttribute("tabindex", "0");
            thumb.addEventListener("keypress", e=>{
                if(e.code === "Enter"){
                    thumb.click();
                }
            })
        });

    }
}

ControlBinders.register(`[data-gallery]`, el => new Gallery(el));
